import moment from "moment";
import "moment/locale/nl";
import "moment/locale/fr";
import * as Sentry from '@sentry/vue';
import 'ckeditor5/dist/ckeditor5.css';
// import 'ckeditor5-premium-features/ckeditor5-premium-features.css';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import VueMarkdown from 'vue-markdown'


//#library
import Vue from "vue";
import $ from "jquery";
import axios from "axios";
import { Component, Provide, Watch } from "vue-property-decorator";
import { ComponentOptions } from "vue/types/options";
import ElementUI from "element-ui";
import * as VueGoogleMaps from "vue2-google-maps";
import posthog from 'posthog-js'
import VeeValidate from "vee-validate";
import Validator from './validator'
import en from "vee-validate/dist/locale/en";
import fr from "vee-validate/dist/locale/fr";
import nl from "vee-validate/dist/locale/nl";
import draggable from "vuedraggable";
import scrollSpy from "vue2-scrollspy";
import { Action, Getter, namespace } from "vuex-class";
import { EmojiPickerPlugin } from "vue-emoji-picker";
//# app components
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import App from "./app/App.vue";
import BaseContainer from "./containers/BaseContainer.vue";
import TreePopoverComponent from "./components/tree-popover/TreePopover.vue";
import FormControlTextInput from "./containers/controls/inputs/Text.vue";
import FormControlItem from "./containers/controls/inputs/FormControlItem.vue";
import UserResourceComponent from "./components/user-resource/UserResourceComponent.vue";
import GridPaginationComponent from "./components/grid/GridPaginationComponent.vue";
import ModalDialogComponent from "./components/modal-dialog/ModalDialogComponent.vue";
import InnerModalDialogComponent from "./components/modal-dialog/InnerModalDialogComponent.vue";
import ExternalMapComponent from "./components/external-map/ExternalMapComponent.vue";
import BaseEditComponent from "./containers/base-edit-component/BaseEditComponent.vue";
import InputNumberFormattedComponent from "./components/input-number-formatted/InputNumberFormattedComponent.vue";
// import DateTimePickerComponent from "./components/datetime-picker/DateTimePickerComponent.vue";
import ExpandSidebarComponent from "./components/expand-sidebar";
import LabelNumberFormattedComponent from "./components/label-number-formatted";
import HistoryTimeLineComponent from "./components/history";
import LabelDateTimeFormattedComponent from "./components/label-datetime-formatted";
import XEditable from "./components/x-editable/XEditable.vue";
import LabelPaginateDisplayComponent from "./components/label-paginate-display";
import DateRangePickerComponent from "./components/date-range-picker";
import OTable from "./components/element-ui/table";
import OTableColumn from "./components/element-ui/table/src/table-column";
import OInput from "./components/element-ui/input";
import { default as CustomElementUITooltip } from "./components/element-ui/tooltip/src/main";
import ODropdown from "./components/element-ui/dropdown/src/dropdown.vue";
import ODropdownItem from "./components/element-ui/dropdown/src/dropdown-item.vue";
import ODropdownMenu from "./components/element-ui/dropdown/src/dropdown-menu.vue";
import OPopover from "./components/element-ui/popover/src/main.vue";
import OSelect from "./components/element-ui/select/src/select.vue";
import OOption from "./components/element-ui/select/src/option.vue";
// import OPagination from './components/element-ui/pagination/src/pager.vue';
import OmnicasaIconComponent from "./components/omnicasa-icon";
import DateInputPicker from "./components/date-input-picker/DateInputPicker.vue";
import NotificationMessage from "./components/notification-message";
import CkeditorHtmlComponent from "./components/ckeditor-html/CKEditorHtmlComponent.vue";
//#constraints
import {
    LOCALSTORAGE_AUTH,
    LOCALSTORAGE_USERSSION,
    LOCALSTORAGE_LANG,
    LOCALSTORAGE_AUTH2,
    LOCALSTORAGE_MAP_OPTIONS,
    LOCALSTORAGE_MAP_REGIONS,
    LOCALSTORAGE_ENV,
    WEBVIEW_TOKEN_QUERY,
    WEBVIEW_REFRESH_TOKEN_QUERY,
    WEBAPP_LAYOUT,
    LANG_NUMBER,
    DEFAULT_DOMAIN
} from "./common/constants";
//#store
import store, { storeModules, storeTypes } from "./store";
import userStoreTypes from "./store/user/user-types.store";
//#utils
import ClickOutSide from "./utils/directives/click-outside";
import DocumentLoader from "./utils/directives/document-loader";
import ImageLoader from "./utils/directives/image-loader";
import TouchDirective from "./utils/directives/touch-directive";

import {
    AuthorizationHandlerFactory,
    WebviewAuthorizationHandlerFactory
} from "./utils/authorization/authorizationFactory";
// import {
// 	AuthorizationHandlerFactory,
// 	AuthorizationResponse,
// 	AuthorizationResponseStatus,
// 	LocalStoredAuthorizationSetting,
// 	AuthorizationRequestFactory
// } from "./utils/authorization/authorizationFactory-bk";
import { AxiosConfigurationHelper } from "./utils/axios-helper";
//#helper
import i18n from "./i18n";
import router from "./router";
import { LabelSetting } from "./i18n/locale-helper";
//#model

import { INavbar } from "./models/app-configuration";
import { AuthTransfer, AuthVerified } from "./models/generic/auth-transfer";
// import { loadProgressBar } from "./utils/axios-progress-bar";
import TranslatorPlugin from "./plugin/Translator";
import FormatterPlugin from "./plugin/extention-format";
import ValidationPlugin from "./plugin/validation";
import RouterHelperPlugin from "./plugin/router-helper";
import LabelDotDotTooltip from "./components/label-dotdot-tooltip";
import JobSchedulerPlugin from "./plugin/jobScheduler";
import ImageLazyLoader from "./utils/directives/image-lazy-loader";
import PerfectScrollBarDirective from "./utils/directives/perfect-scrollbar-directive";
import SelectInputTextComponent from "./containers/controls/select-input-text";
import InputNumberDirective from "./utils/directives/number";

import "./utils/extension/date-extension";
import { IAuthConfigModel } from "./models/user/auth-config.model";
import DecimalFormatByLocale from "./plugin/decimal-format";

import("./assets/omnicasa");
import "./utils/class-component-hooks";
import MultipleTabPlugin from "./plugin/tab";
import PhonesComponent from "./components/phones";
import EmailsComponent from "./components/emails";
import { ModalConfirmPlugin } from "./plugin/modal-confirm";
import SignalRPlugin from "./plugin/signalr";
import { LocalforageWrapper } from "./utils/localforage-wrapper";
import { AuthorizationResponse } from "./utils/authorization/data-model";
import EventTracker from "./utils/event-tracker";
import { ServiceVersionReader } from "./utils/version/version-helper";
import {
    captureAppError,
    hasSentryInitialized,
    installErrorReporter,
    markSentryInitialized,
    setSentryCaptureEnabled,
    setupGlobalSentryHandlers
} from "./utils/error-reporter";

const VueScrollTo = require("vue-scrollto");
const CommonAction = namespace(storeModules.Common, Action);
const UserAction = namespace(storeModules.User, Action);
const CommonGetter = namespace(storeModules.Common, Getter);
const UserGetter = namespace(storeModules.User, Getter);

let currentValidatorInstance = null;

function resolveSentryEnvironment(authData: any): string {
    const rawEnvironment = (authData?.environment || "").toString().toLowerCase();
    const runtimeEnvironment =
        typeof process !== "undefined" && process.env && process.env.NODE_ENV
            ? process.env.NODE_ENV.toLowerCase()
            : undefined;

    return rawEnvironment === "release"
        ? "production"
        : rawEnvironment || runtimeEnvironment || "";
}

Vue.config["locales"] = require("./json/languages.json");

//Register components globally
Vue.component("o-form-control-input", FormControlTextInput);
Vue.component("o-form-control-item", FormControlItem);
Vue.component("o-container", BaseContainer);
Vue.component("o-modal", ModalDialogComponent);
Vue.component("o-inner-modal", InnerModalDialogComponent);
Vue.component("o-grid-pagination", GridPaginationComponent);
Vue.component("o-user-resource", UserResourceComponent);
Vue.component("o-tree-popover", TreePopoverComponent);
Vue.component("o-external-map", ExternalMapComponent);
Vue.component("o-input-number", InputNumberFormattedComponent);
// Vue.component("o-datepicker", DateTimePickerComponent);
Vue.component("o-datepicker", DateInputPicker);
Vue.component("o-history-timeline", HistoryTimeLineComponent);
Vue.component("o-expand-sidebar", ExpandSidebarComponent);
Vue.component("o-number-label", LabelNumberFormattedComponent);
Vue.component("o-editable", XEditable);
Vue.component("o-datetime-label", LabelDateTimeFormattedComponent);
Vue.component("o-paginate-display-label", LabelPaginateDisplayComponent);
Vue.component("o-date-range-picker", DateRangePickerComponent);
Vue.component("o-dotdot-tooltip", LabelDotDotTooltip);
Vue.component("o-table", OTable);
Vue.component("o-table-column", OTableColumn);
Vue.component("o-dropdown", ODropdown);
Vue.component("o-dropdown-item", ODropdownItem);
Vue.component("o-dropdown-menu", ODropdownMenu);
Vue.component("o-popover", OPopover);
Vue.component("o-select-input", SelectInputTextComponent);
Vue.component("o-input", OInput);
Vue.component("o-select", OSelect);
Vue.component("o-option", OOption);
Vue.component("el-tooltip", CustomElementUITooltip);
Vue.component("o-phones", PhonesComponent);
Vue.component("o-emails", EmailsComponent);
Vue.component("edit-container", BaseEditComponent);
// Vue.component('el-pagination', OPagination);
Vue.component("o-icon", OmnicasaIconComponent);
Vue.component("notification-message", NotificationMessage);
//Register third-party
Vue.component("ckeditor-html", CkeditorHtmlComponent);
Vue.component("vue-markdown", VueMarkdown);

let lang = localStorage.getItem(LOCALSTORAGE_LANG);
lang = lang === null ? "en" : lang.substring(0, 2);
Vue.use(ElementUI, {
    locale: require("element-ui/lib/locale/lang/" + lang).default,
    size: "mini"
});
Vue.use(CKEditor);
Vue.use(ModalConfirmPlugin);
installErrorReporter(Vue);
setupGlobalSentryHandlers();

try {
    const bootstrapAuthRaw = localStorage.getItem(LOCALSTORAGE_AUTH2) as any;
    const bootstrapAuthData = bootstrapAuthRaw ? JSON.parse(bootstrapAuthRaw) : {};
    const bootstrapEnvironment = resolveSentryEnvironment(bootstrapAuthData);
    setSentryCaptureEnabled(bootstrapEnvironment === "production");
} catch {
    setSentryCaptureEnabled(false);
}

Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyAftupqdQNac88oZ_3d8MRT2hVXbKlZZ1Y",
        v: "weekly",
        libraries: "places"
    }
});

Vue.filter("confirmContent", value => {
    if (value == null) return "";
    let arr = value.split("|") || [];
    if (arr.length > 1) return arr[0];
    return "";
});

Vue.filter("confirmTitle", value => {
    if (value == null) return "";
    let arr = value.split("|") || [];
    if (arr.length > 1) return arr[1];
    return "";
});

//Registor Mixins
// Vue.mixin(TranslatorMixin);
// Vue.mixin(DateFormatMixin);
// Vue.mixin(NumberFormatMixin);
// Vue.mixin(CompareObjectMixin);
// Vue.mixin(ValidationMixin);
// Vue.mixin(GridMixin);
Vue.mixin({
    mounted() {
        if (this.$validator) {
            currentValidatorInstance = this.$root.$validator;
        }
    }
})

Vue.use(TranslatorPlugin);
Vue.use(FormatterPlugin);
//Vue.use(GridPlugin);
Vue.use(ValidationPlugin);
Vue.use(RouterHelperPlugin);
Vue.use(SignalRPlugin, {
    url: "https://notification-signalr." + DEFAULT_DOMAIN + "/notifications", //Production,
    urlTest: "https://notification-signalr." + DEFAULT_DOMAIN + "/notifications" //test,
});
Vue.use(MultipleTabPlugin);
Vue.use(JobSchedulerPlugin);
Vue.directive("image-lazy-loader", new ImageLazyLoader());
Vue.directive("perfect-scrollbar", new PerfectScrollBarDirective());
Vue.directive("touch-event-handle", TouchDirective);
Vue.directive("image-loader", new ImageLoader());
Vue.directive("document-loader", new DocumentLoader());
Vue.directive("click-outside", new ClickOutSide());
Vue.component("draggable", draggable);
Vue.directive("input-number", new InputNumberDirective());
// Merge the locales.

const config = {
    strict: true,
    enableAutoClasses: false,
    inject: true,
    errorBagName: "errorsValidation", // change if property conflicts
    fieldsBagName: "fieldsValidation"
};

Vue.use(VeeValidate, config);

// use default options
Vue.use(scrollSpy);

// using scrollto
Vue.use(VueScrollTo, {
    container: ".modal-container-scroll",
    duration: 500,
    easing: "ease",
    offset: -50,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
});

Vue.use(DecimalFormatByLocale);

const greaterZeroValidator = {
    getMessage(field, args) {
        return `The ${field} should be greater then zero`;
    },
    validate(value, args) {
        return value > 0;
    }
};

Validator.extend("greater_zero", greaterZeroValidator);
Validator.extend('over_17_and_6_months', {
    getMessage: field => 'You must be at least 17 years and 6 months old.',
    validate: value => {
      if (!value) {
        return false;
      }
  
      const inputDate = new Date(value);
      const today = new Date();
      const seventeenYearsAndSixMonthsAgo = new Date(today.getFullYear() - 17, today.getMonth() - 6, today.getDate());
  
      return inputDate <= seventeenYearsAndSixMonthsAgo;
    }
  });


Vue.use(EmojiPickerPlugin);

Vue.prototype.$checkUserRights = function (sectionName, rightId) {
    if (!this.userRights || !this.userRights.Sections) {
        return false;
    }

    // SectionName comes back localized from the backend (e.g. 'Général' in FR,
    // 'Algemeen' in NL), so matching by name only works for users whose locale
    // happens to match the hardcoded English value. rightId is numeric and
    // locale-independent — fall back to scanning all sections by rightId when
    // the name lookup fails.
    let userRight;
    const section = this.userRights.Sections.find(
        e => e.SectionName === sectionName
    );
    if (section && section.UserRights && section.UserRights.length > 0) {
        userRight = section.UserRights.find(e => e.Id === rightId);
    }
    if (!userRight) {
        for (const s of this.userRights.Sections) {
            userRight = s.UserRights?.find(e => e.Id === rightId);
            if (userRight) break;
        }
    }
    if (!userRight) {
        return false;
    }

    const userGroupId = this.authConfig?.UserInfo?.GroupId;

    return userRight?.SelectedGroupIds?.includes(userGroupId);
};
@Component({
    template: "<App/>",
    components: {
        App
    },
    created: function () { },
    $_veeValidate: {
        validator: "new" // give me my own validator scope.
    }
})
class RootApp extends Vue {
    globalLocalizeSetting = LabelSetting.Global;

    axiosConfig: AxiosConfigurationHelper;
    @CommonAction(storeTypes.Set.PAGEREADY)
    storeSetPageReady: (status: boolean) => void;

    @CommonAction(storeTypes.Set.WEBAPP_LAYOUT)
    private storeSetWebappLayout: (layoutMode: string) => void;

    @UserAction(userStoreTypes.Get.AUTH_CONFIG)
    getAuthConfig: (i18n: any) => void;

    @CommonAction(storeTypes.Set.USERSESSION)
    storeSetUserSession: (session: {
        config: AuthTransfer;
        userInfo: AuthVerified;
    }) => void;
    @CommonGetter navbar: INavbar;
    @CommonGetter userSession: AuthVerified;
    @UserGetter authConfig: IAuthConfigModel;

    @UserAction(userStoreTypes.Get.USER_RIGHTS)
    getUserRights: () => Promise<any>;

    constructor(options?: ComponentOptions<Vue>) {
        super(options);
        this.axiosConfig = new AxiosConfigurationHelper();
    }

    async created() {
        axios.interceptors.request.use(
            config => {
                //   this.startProgress();
                return this.axiosConfig.axiosRequestHandler(config, this.$i18n);
            },
            error => {
                captureAppError(error, {
                    tags: { origin: "axios.request" },
                    extra: {
                        url: error?.config?.url,
                        method: error?.config?.method
                    }
                });
                console.log(error);
                //   this.stopProgress();
                // return this.axiosConfig.axiosExceptionHandler(error);
                return Promise.reject(error);
            }
        );
        axios.interceptors.response.use(
            response => {
                // this.stopProgress();
                if (response.status >= 400) {
                    EventTracker.logEvent({
                        FormName: "RequestApiError",
                        Action: "CallApi",
                        FormId: 0,
                        Comment: {
                            api: response.request.responseURL,
                            status: response.status
                        }
                    });
                }
                return this.axiosConfig.axiosResponseHandler(response);
            },
            error => {
                const config = error?.config || {};
                captureAppError(error, {
                    tags: { origin: "axios.response" },
                    extra: {
                        url: config?.url,
                        method: config?.method,
                        status: error?.response?.status,
                        statusText: error?.response?.statusText
                    }
                });
                return Promise.reject(error);
                // this.stopProgress();
                // return this.axiosConfig.axiosExceptionHandler(error);
            }
        );


        axios.defaults.validateStatus = (status: number): boolean =>
            this.axiosConfig.axiosHandleValidStatus(status);

        console.log("start authorized...");
        await this.handleAuthenticationNew();

        // Init must complete before handleLogRecord so handleLogSentry sees
        // hasSentryInitialized(); but a Posthog/Sentry init throw must NOT
        // prevent storeSetPageReady (which gates the entire UI render).
        try {
            await this.handleInitRecord();
        } catch (error) {
            captureAppError(error, {
                tags: { origin: "init-record" }
            });
        }
        this.handleLogRecord()

        this.checkOmnicasaMailSenderStatus();

        this.storeSetPageReady(true);
        // localize for validation
        if (this.$i18n.locale.substring(0, 2) != "en") {
            this.handleLocalizeChange();
        }

        // loadProgressBar({}, axios);
        let currentLanguage = localStorage.getItem("lang");
        let localeName = currentLanguage.substr(0, 2);
        console.log("time-zone--setlocale: ", localStorage);
        console.log("time-zone--localeData: ", localeName);

        switch (localeName) {
            case "nl":
                moment.locale("nl");
                break;
            case "fr":
                moment.locale("fr");
                break;
            default:
                moment.locale(localeName);
                break;
        }
        console.log("INIT LOCALE FOR MOMENT0 :" + currentLanguage);
        this.extendCustomValidationRules();
    }

    initializePosthog() {
        // ✅ Step 0: Re-init PostHog first — clean slate
        // Base64-encoded to prevent deploy_staging.py from replacing "omnicasa.com" → "omnicasa.com"
        // Decoded value: https://improving.omnicasa.com
        const posthogApiHost = atob('aHR0cHM6Ly9pbXByb3Zpbmcub21uaWNhc2EuY29t');
        posthog.init("phc_LtZkNjxg3EGBPaW1kdsAkK9IlPqJOTIkE5r6Wod1lyn", {
            api_host: posthogApiHost,
            ui_host: 'https://eu.posthog.com',
            persistence: 'localStorage',
            autocapture: true,
            disable_session_recording: false,
            session_recording: {
              captureCanvas: {
                canvasFps: 2,
                canvasQuality: "0.2"
              }
            }
          });
          

        // ✅ Step 1: Hard reset
        posthog.reset();
    }

    extendCustomValidationRules() {
        Validator.extend('required_one_of', {
            getMessage: (field: string, params: string[]) => {
                console.log('this is start getMessage')
                const fieldNames = params.join(', ');
                return `REQUIRED_ONE_OF_FIELDS||${fieldNames}`;
            },
            validate: (value: any, params: any) => {
                if (typeof value === 'string' && value?.length > 0 && value !== 'undefined') {
                    return true;
                }
    
                const fields = currentValidatorInstance?.fields.items
                if (params?.length > 0) {
                    const hasValue = params.some(fieldName => {
                        return fields.some(field => {
                            const isOneOfFields =  field?.model?.expression?.split('.')?.[1] === fieldName
                            if (isOneOfFields) {
                                return !!field?.value;
                            }
                        });
                    })
                    return hasValue;
                }
                return false;
            },
        });
    }

    initializeClarity() {
        (function (c, l, a, r, i, t, y) {
            c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
            t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
            y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
        })(window, document, "clarity", "script", "n82xa5z1ld");
    }

    initializeSentry() {
        let authData = localStorage.getItem(LOCALSTORAGE_AUTH2) as any;
        authData = authData ? JSON.parse(authData) : {};

        try {
            Sentry.init({
                Vue,
                dsn: "https://28a492f2dc96b86ccda22d59aca2beb4@o4507973331910656.ingest.de.sentry.io/4507973339512912",
                environment: authData?.environment === 'release' ? 'production' : (authData?.environment || 'production'),
                integrations: [
                    posthog.sentryIntegration({
                        organization: 'omnicasa-sentry',
                        projectId: 4507973339512912,
                        severityAllowList: ['error', 'info'] // optional: here is set to handle captureMessage (info) and captureException (error)
                      }
                    ),
                    Sentry.browserTracingIntegration({ router }),
                    Sentry.replayIntegration({
                        maskAllText: false,
                        blockAllMedia: false,
                        networkDetailAllowUrls: [/webapinew/i],
                        networkRequestHeaders: ['X-Custom-Header'],
                        networkResponseHeaders: ['X-Custom-Header'],
                        networkCaptureBodies: true,
                        beforeAddRecordingEvent: (event: any) => {
                            if (['bam.eu01.nr-data.net', 'smartlook', 'posthog', 'improving.omnicasa.com', 'google'].some(url => event?.data?.payload?.description?.includes(url))) {
                                return null
                            }

                            return event
                        }
                    }),
                ],
                ignoreErrors: ['Network Error'],
                beforeSend(event, hint) {
                    const error = hint?.originalException as any;
                    const environment = authData?.environment;

                    // Drop everything outside production so the SDK's own
                    // integrations (Vue handler, browser tracing, replay) do
                    // not leak dev/staging traffic into Sentry.
                    if (environment !== "release") {
                        return null;
                    }

                    if (error?.message?.match(/Network Error/i)) {
                        return null;
                    }
                    return event;
                },
                // Set tracesSampleRate to 1.0 to capture 100%
                // of transactions for tracing.
                // We recommend adjusting this value in production
                tracesSampleRate: 1.0,

                // // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
                // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],

                // Capture Replay for 10% of all sessions,
                // plus for 100% of sessions with an error
                replaysSessionSampleRate: 1.0,
                replaysOnErrorSampleRate: 1.0,
            });
            markSentryInitialized();
        } catch (error) {
            console.error("Sentry initialization failed", error);
            captureAppError(error, {
                tags: { origin: "sentry.init" }
            });
        }
    }

    async handleInitRecord() {
        // Posthog
        await this.initializePosthog()
        // Sentry
        await this.initializeSentry()
    }

    checkOmnicasaMailSenderStatus() {
        const warning = this.authConfig?.MailSenderWarning;
        if (!warning?.Show || !warning.Message) {
            return;
        }
        this.$notify({
            title: this.$t("WARNING").toString(),
            dangerouslyUseHTMLString: true,
            message: `<div class="notification-message-custom">${warning.Message}</div>`,
            type: "warning",
            duration: 0,
            customClass: "warning"
        });
    }

    // handleLogNewRelict() {
    //     const userInfo = this.userSession.UserInfo;
    //     let authData = localStorage.getItem(LOCALSTORAGE_AUTH2) as any;
    //     authData = authData ? JSON.parse(authData) : {};
    //     const that = window as any;

    //     //@ts-ignore
    //     if (that.newrelic) {
    //         // Clear previous custom attributes (if applicable)
    //         that.newrelic.setCustomAttribute('userId', '');
    //         that.newrelic.setCustomAttribute('userEmail', '');
    //         that.newrelic.setCustomAttribute('userName', '');

    //         // Optionally clear userId
    //         that.newrelic.setUserId(null);


    //         that.newrelic.setCustomAttribute('session_replay', { enabled: true });
    //         // Log interaction or start a new interaction context
    //         const interaction = that.newrelic.interaction().setName('User Login');

    //         // Set new user attributes
    //         let customUserInfo = userInfo?.Id.toString();
    //         if (userInfo?.Name) {
    //             customUserInfo += `_${userInfo?.Name}`;
    //         }
    //         if (userInfo?.Email) {
    //             customUserInfo += `_${userInfo?.Email}`;
    //         }

    //         // Set custom attributes for user tracking
    //         that.newrelic.setUserId(customUserInfo);
    //         that.newrelic.setCustomAttribute('userId', userInfo?.Id.toString());
    //         that.newrelic.setCustomAttribute('userEmail', userInfo?.Email);
    //         that.newrelic.setCustomAttribute('userName', userInfo?.Name);
    //         if (authData?.data && authData?.data?.information) {
    //             that.newrelic.setCustomAttribute('customerName', authData?.data?.information?.customerName);
    //         }

    //         // Save the interaction
    //         interaction.save();

    //         console.log('NewRelic session updated with user information');
    //     }
    // }


    handleLogSentry() {
        if (!hasSentryInitialized()) {
            return;
        }

        const userInfo = this.userSession?.UserInfo;
        let authData = localStorage.getItem(LOCALSTORAGE_AUTH2) as any;
        authData = authData ? JSON.parse(authData) : {};

        Sentry.setUser({
            email: userInfo?.Email,
            username: userInfo?.Name,
            company: userInfo?.CompanyName,
            customerName: authData?.data?.information?.customerName
        })

        Sentry.setTag('customerName', authData?.data?.information?.customerName)
    }

    handleLogPosthog() {
        // ✅ Step 4: Delay and re-identify
        setTimeout(() => {
            // Force a new session with an event
            posthog.capture('$pageview');

            const userInfo = this.userSession?.UserInfo;
            let authData = localStorage.getItem(LOCALSTORAGE_AUTH2) as any;
            authData = authData ? JSON.parse(authData) : {};

            // Identify the new user AFTER session is kicked off
            posthog.identify(`${userInfo?.Id.toString()}_${Math.random()}`, {
            userEmail: userInfo?.Email,
            userName: userInfo?.Name,
            email: userInfo?.Email,
            name: userInfo?.Name,
            customerName: authData?.data?.information?.customerName
            });
        }, 300); // increase timeout slightly for consistency
    }

    handleLogRecord() {
        // Posthog
        this.handleLogPosthog()
        // Sentry
        this.handleLogSentry()

        // New Relic
        // this.handleLogNewRelict()
    }

    handleLogClarity() {
        const userInfo = this.userSession?.UserInfo;
        let authData = localStorage.getItem(LOCALSTORAGE_AUTH2) as any;
        authData = authData ? JSON.parse(authData) : {};
        let customerName = authData?.data?.information?.customerName;
        const Window: any = window;
        Window.clarity("identify", userInfo?.Email, undefined, undefined, customerName)
    }

    mounted() {
        this.$watch(
            "axiosConfig.serviceUnavailable",
            (val, oldVal) => this.handleDiconnect(),
            { deep: true }
        );
        this.$watch(
            "axiosConfig.sessionExpired",
            (val, oldVal) => this.handleSessionExpired(),
            { deep: true }
        );
        console.log("domain:" + DEFAULT_DOMAIN);
        console.log('this is this', this)
    }
    @Watch("axiosConfig.serviceAvailable", { deep: true })
    handlePageInitialized(value) {
        if (value) {
            setTimeout(() => $("#loadingContainer").fadeOut("slow"), 500);
        }
    }
    _sessionExpiredCleanner: any;
    handleSessionExpired() {
        clearTimeout(this._sessionExpiredCleanner);
        this._sessionExpiredCleanner = setTimeout(() => {
            this.$confirm(
                this.$t(LabelSetting.Status.sessionExpired).toString(),
                this.$t(LabelSetting.Global.ConfirmWarning).toString(),
                {
                    type: "error",
                    confirmButtonText: this.$t(
                        LabelSetting.Action.ok
                    ).toString(),
                    cancelButtonText: this.$t(
                        LabelSetting.Action.cancel
                    ).toString(),
                    confirmButtonClass: "el-button--danger"
                }
            )
                .then(() => {
                    location.href =
                        "//" + Vue.config[LOCALSTORAGE_AUTH].originDomain;
                })
                .catch(() => { });
        }, 300);
    }
    _disconnectPopopVisibleCleaner: any;
    handleDiconnect() {
        clearTimeout(this._disconnectPopopVisibleCleaner);
        this._disconnectPopopVisibleCleaner = setTimeout(() => {
            this.$confirm(
                this.$t(LabelSetting.Status.disconnected).toString(),
                this.$t(LabelSetting.Global.ConfirmWarning).toString(),
                {
                    type: "error",
                    confirmButtonText: this.$t(
                        LabelSetting.Action.ok
                    ).toString(),
                    cancelButtonText: this.$t(
                        LabelSetting.Action.cancel
                    ).toString(),
                    confirmButtonClass: "el-button--danger"
                }
            )
                .then(() => {
                    location.reload();
                })
                .catch(() => { });
        }, 300);
    }

    async handleAuthenticationNew() {
        try {
            const urlQuery = new URLSearchParams(location.search);
            const webviewToken = urlQuery.get(WEBVIEW_TOKEN_QUERY);
            const webviewRefreshToken = urlQuery.get(WEBVIEW_REFRESH_TOKEN_QUERY);
            if (webviewToken) {
                // handle set layout mode: webview
                this.storeSetWebappLayout(WEBAPP_LAYOUT.WEBVIEW);
                const environment = urlQuery.get("environment");
                const webApiVersion = urlQuery.get("web-api-version");
                const webAppVersion = urlQuery.get("web-app-version");
                // const webViewLang = urlQuery.get('lang');
                const webViewLang = urlQuery.get("webview-lang");
                const isMasterUser = urlQuery.get("webview-support");
                const query = {};
                if (environment) {
                    query["environment"] = environment;
                    localStorage.setItem(LOCALSTORAGE_ENV, environment);
                }
                if (webApiVersion) query["web-api-version"] = webApiVersion;
                if (webAppVersion) query["web-app-version"] = webAppVersion;
                // query['is-master'] = urlQuery.get('is-master');
                if (isMasterUser) {
                    query["is-master"] = isMasterUser === "1";
                }

                if (webViewLang) {
                    // window['webViewLang'] = webViewLang;
                    switch (Number(webViewLang)) {
                        case LANG_NUMBER.FR:
                            window["webViewLang"] = "fr";
                            break;
                        case LANG_NUMBER.NL:
                            window["webViewLang"] = "nl";
                            break;
                        default:
                            window["webViewLang"] = "en";
                            break;
                    }
                }
                await new WebviewAuthorizationHandlerFactory(webviewToken, webviewRefreshToken)
                    .verifyToken(query)
                    .then(async (response) => {
                        // WA-4614 Store AI_URL
                        this.storeAuthorizationResponse(response);
                        return this.getAuthConfig(this.$i18n);
                    })
                    .catch(err => {
                        captureAppError(err, {
                            tags: { origin: "authentication.verify-webview-token" }
                        });
                        this.$router.push("/unauthorized");
                    });
            } else {
                (await new AuthorizationHandlerFactory()
                    .authenticationHandler()
                    .then(async (response: any) => {
                        //WA-3578: Check upgrade version web api, update local storage
                        if (
                            response.Config.environment !== "dev" &&
                            response.Config.environment !== "staging"
                        ) {
                            const service = new ServiceVersionReader();
                            const newestVersion = await service.getVersion(
                                "release"
                            );
                            if (
                                newestVersion.webApiVersion !==
                                response.Config.apiVersion
                            ) {
                                await new AuthorizationHandlerFactory(
                                    newestVersion.webApiVersion
                                ).authenticationHandler();
                            }
                        }
                        const environment = urlQuery.get("environment");
                        if (environment) {
                            localStorage.setItem(LOCALSTORAGE_ENV, environment);
                        }

                        this.storeAuthorizationResponse(response);
                        return this.getAuthConfig(this.$i18n);
                    })
                    .catch(err => {
                        captureAppError(err, {
                            tags: { origin: "authentication.authorization-handler" }
                        });
                    })) as any;
            }
            await this.getUserRights();
        } catch (error) {
            captureAppError(error, {
                tags: { origin: "authentication.new" }
            });
            localStorage.removeItem(LOCALSTORAGE_AUTH);
            localStorage.removeItem(LOCALSTORAGE_AUTH2);
            localStorage.removeItem(LOCALSTORAGE_USERSSION);
            localStorage.removeItem(LOCALSTORAGE_MAP_OPTIONS);
            localStorage.removeItem(LOCALSTORAGE_MAP_REGIONS);
            LocalforageWrapper.clear();
            const loginUrlEl = document.querySelector("meta[name='Login-Url']");

            if (loginUrlEl) {
                location.href = loginUrlEl.getAttribute("content");
            }
        }
    }

    storeAuthorizationResponse(response: AuthorizationResponse) {
        try {
            Vue.config[LOCALSTORAGE_AUTH] = response.Config;
            Vue.config[LOCALSTORAGE_USERSSION] = response.UserInfo;
            this.storeSetUserSession({
                config: response.Config,
                userInfo: response.UserInfo
            });
            this.$socket.start({
                accessToken: response.Config.token
            });
        } catch (ex) { }
    }
    redirectToAgendaPage(response) {
        this.$router.push({
            path: "/agenda"
        });
    }

    @Watch("$i18n.locale", { deep: true })
    handleLocalizeChange() {
        // Localize takes the locale object as the second argument (optional) and merges it.
        let code = this.$i18n.locale.substring(0, 2);
        switch (code) {
            case "en":
                Validator.localize("en", en);
                break;
            case "fr":
                Validator.localize("fr", fr);
                break;
            case "nl":
                Validator.localize("nl", nl);
                break;
        }
    }

    /**
     * get localization
     */
    get actionLocalizationConfig() {
        return LabelSetting.Action;
    }

    get coUserAuthConfig() {
        return this.authConfig;
    }

    @Provide()
    handleGetIconResourceUrl(imageName: string) {
        if (!imageName) {
            return null;
        }
        return `${this.coUserAuthConfig.BaseIconResourceUrl}/showonlist/${imageName}`;
    }
}

if (window["PREVENT_RENDER_WEBAPP"] !== true) {
    new RootApp({
        i18n,
        router,
        store
    }).$mount("#app");
}
